module.exports = __webpack_public_path__ + "assets/img/Seller.6611944d.jpg";